// import React, { useState } from 'react';
// import {
//   Table,
//   Spinner,
//   Form,
//   Row,
//   Col,
//   Button,
//   Alert,
//   Badge,
//   CardFooter,
//   CardTitle,
//   ProgressBar
// } from 'react-bootstrap';
// import 'react-datepicker/dist/react-datepicker.css';
// import { Card, CardBody, CardHeader } from '@components/card/card';
// import { ntxAPI } from '@API/axiosNeatex';
// import useGetItemsList from '@hooks/INV/MasterItems/useGetItemsList';
// import Select from 'react-select';
// import { useTranslation } from 'react-i18next';
// import type { APIResponse } from '@store/Shared/shared';
// import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';

// import Loading from '@components/Shared/Loader/Loading';

// interface ReorderPoint {
//   itemId: string;
//   itemCode: string;
//   itemName: string;
//   itemName2: string;
//   onHandQty: number;
//   minQty: number;
//   maxQty: number;
//   reorderPoint: number;
//   status: string;
// }

// const ReorderPointReport: React.FC = () => {
//   const [data, setData] = useState<ReorderPoint[]>([]);
//   const [loading, setLoading] = useState<boolean>(false);
//   const [error, setError] = useState<string | null>(null);

//   const { ItemsOptions, loading: loading1, error: error1 } = useGetItemsList();
//   const { InventoryOptions, loading: loading2, error: error2 } = useGetInventoryWithPermission();
//   const { t, i18n } = useTranslation();
//   const [showZeroQuantity, setShowZeroQuantity] = useState<boolean>(false);

//   const [statusFilter, setStatusFilter] = useState<string>('all');
//   const [urgencyFilter, setUrgencyFilter] = useState<string>('all');

//   // Filter states
//   const [itemId, setItemId] = useState<string | null>('');
//   const [inventoryId, setInventoryId] = useState<string | null>('');

//   const fetchData = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const { data } = await ntxAPI.get<APIResponse<ReorderPoint[]>>(`InventoryReports/reorder-point`, {
//         params: {
//           ItemId: itemId,
//           InventoryId: inventoryId
//         }
//       });

//       if (data.succeeded === true) {
//         setData(data.data);
//       } else {
//         setError(data instanceof Error ? data.message : t('UnknownError'));
//       }
//     } catch (err) {
//       setError(err instanceof Error ? err.message : t('UnknownError'));
//     } finally {
//       setLoading(false);
//     }
//   };

//   const resetFilters = () => {
//     setItemId(null);
//     setInventoryId(null);
//     setStatusFilter('all');
//     setUrgencyFilter('all');
//   };

//   // Get unique statuses for dropdown
//   const getUniqueStatuses = () => {
//     const statuses = data.map(item => item.status);
//     return Array.from(new Set(statuses));
//   };

//   // Get unique items for dropdown (optional)
//   const getUniqueItems = () => {
//     const items = data.map(item => ({
//       id: item.itemId,
//       code: item.itemCode,
//       name: item.itemName
//     }));

//     return Array.from(new Map(items.map(item => [item.id, item])).values());
//   };

//   const formatQuantity = (quantity: number): string => {
//     return new Intl.NumberFormat('en-US').format(quantity);
//   };

//   // Get status badge color
//   const getStatusBadgeColor = (status: string) => {
//     switch (status) {
//       case 'Below Minimum':
//         return 'danger';
//       case 'Above Maximum':
//         return 'warning';
//       case 'Within Range':
//         return 'success';
//       case 'At Reorder Point':
//         return 'info';
//       default:
//         return 'secondary';
//     }
//   };

//   // Calculate urgency level
//   const getUrgencyLevel = (item: ReorderPoint) => {
//     if (item.onHandQty === 0) return 'critical';
//     if (item.onHandQty < item.minQty) return 'high';
//     if (item.onHandQty > item.maxQty) return 'medium';
//     return 'low';
//   };

//   // Calculate inventory level percentage
//   const getInventoryLevel = (item: ReorderPoint) => {
//     if (item.maxQty === 0) return 0;
//     return Math.min((item.onHandQty / item.maxQty) * 100, 100);
//   };

//   // Calculate inventory statistics
//   const calculateInventoryStats = () => {
//     const belowMin = data.filter(item => item.status === 'Below Minimum').length;
//     const aboveMax = data.filter(item => item.status === 'Above Maximum').length;
//     const withinRange = data.filter(item => item.status === 'Within Range').length;
//     const totalItems = data.length;
//     const outOfStock = data.filter(item => item.onHandQty === 0).length;
//     const needReorder = data.filter(item => item.onHandQty <= item.minQty && item.onHandQty > 0).length;

//     return { belowMin, aboveMax, withinRange, totalItems, outOfStock, needReorder };
//   };

//   // Filter data based on status and urgency
//   const filteredData = data.filter(item => {
//     if (statusFilter !== 'all' && item.status !== statusFilter) return false;

//     if (urgencyFilter !== 'all') {
//       const urgency = getUrgencyLevel(item);
//       if (urgencyFilter === 'critical' && urgency !== 'critical') return false;
//       if (urgencyFilter === 'high' && urgency !== 'high') return false;
//       if (urgencyFilter === 'medium' && urgency !== 'medium') return false;
//       if (urgencyFilter === 'low' && urgency !== 'low') return false;
//     }

//     return true;
//   });

//   const { belowMin, aboveMax, withinRange, totalItems, outOfStock, needReorder } = calculateInventoryStats();

//   return (
//     <div className='container mt-4'>
//       <Card>
//         <CardHeader className='d-flex justify-content-between align-items-center'>
//           <h5 className='mb-0'>Reorder Point Report</h5>
//           {data.length > 0 && (
//             <div>
//               <span className='me-2'>
//                 Showing: {filteredData.length} of {data.length} items
//               </span>
//             </div>
//           )}
//         </CardHeader>

//         <CardBody>
//           {error && (
//             <Alert variant='danger' className='mb-4'>
//               Error loading data: {error}
//             </Alert>
//           )}

//           {/* Filters Section */}
//           <Card className='mb-4'>
//             <CardHeader>{i18n.language === 'en' ? 'Filters' : 'الفلاتر'}</CardHeader>
//             <Loading loading={loading1 || loading2} error={error1 || error2}>
//               <CardBody>
//                 <Form>
//                   <Row className='g-3'>
//                     <Col md={4}>
//                       <Form.Group>
//                         <Form.Label>{t('itemName')}</Form.Label>
//                         <Select
//                           classNamePrefix='react-select'
//                           isSearchable
//                           isClearable
//                           options={ItemsOptions}
//                           onChange={(option: any) => setItemId(option?.value || null)}
//                           value={ItemsOptions.find(f => f.value === itemId)}
//                           placeholder={t('Choose')}
//                           menuPortalTarget={document.body}
//                           styles={{
//                             menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                           }}
//                         />
//                       </Form.Group>
//                     </Col>

//                     <Col md={4}>
//                       <Form.Group>
//                         <Form.Label>{t('Inventory')}</Form.Label>
//                         <Select
//                           classNamePrefix='react-select'
//                           isSearchable={true}
//                           isClearable
//                           options={InventoryOptions}
//                           onChange={(option: any) => {
//                             setInventoryId(option === null ? null : option.value);
//                           }}
//                           placeholder={t('Choose')}
//                         />
//                       </Form.Group>
//                     </Col>

//                     <Col md={4}>
//                       <Form.Group controlId='urgencyFilter'>
//                         <Form.Label>Urgency Level</Form.Label>
//                         <Form.Select value={urgencyFilter} onChange={e => setUrgencyFilter(e.target.value)}>
//                           <option value='all'>All Urgency Levels</option>
//                           <option value='critical'>Critical (Out of Stock)</option>
//                           <option value='high'>High (Below Minimum)</option>
//                           <option value='medium'>Medium (Above Maximum)</option>
//                           <option value='low'>Low (Within Range)</option>
//                         </Form.Select>
//                       </Form.Group>
//                     </Col>

//                     <Col xs={12} className={`text-end `}>
//                       <Button variant='secondary' onClick={resetFilters} className='me-2'>
//                         {i18n.language === 'en' ? 'Reset Filters' : 'إعادة تعيين الفلاتر'}
//                       </Button>
//                       <Button variant='primary' onClick={fetchData} disabled={loading}>
//                         {loading ? (
//                           <>
//                             <Spinner
//                               as='span'
//                               animation='border'
//                               size='sm'
//                               role='status'
//                               aria-hidden='true'
//                               className='me-2'
//                             />
//                             {i18n.language === 'en' ? 'Loading...' : 'جاري التحميل...'}
//                           </>
//                         ) : i18n.language === 'en' ? (
//                           'Load Report'
//                         ) : (
//                           'تحميل التقرير'
//                         )}
//                       </Button>
//                     </Col>
//                   </Row>
//                 </Form>
//               </CardBody>
//             </Loading>
//           </Card>

//           {/* Inventory Status Summary */}
//           {data.length > 0 && (
//             <Row className='mb-4'>
//               <Col md={2}>
//                 <Card className='text-center  shadow-sm'>
//                   <CardBody className='p-3'>
//                     <CardTitle className='fs-6 text-primary'>Total Items</CardTitle>
//                     <h4 className='text-primary'>{totalItems}</h4>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col md={2}>
//                 <Card className='text-center  shadow-sm'>
//                   <CardBody className='p-3'>
//                     <CardTitle className='fs-6 text-danger'>Below Minimum</CardTitle>
//                     <h4 className='text-danger'>{belowMin}</h4>
//                     <small className='text-muted'>{((belowMin / totalItems) * 100).toFixed(1)}%</small>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col md={2}>
//                 <Card className='text-center border-0'>
//                   <CardBody className='p-3'>
//                     <CardTitle className='fs-6 text-warning'>Above Maximum</CardTitle>
//                     <h4 className='text-warning'>{aboveMax}</h4>
//                     <small className='text-muted'>{((aboveMax / totalItems) * 100).toFixed(1)}%</small>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col md={2}>
//                 <Card className='text-center border-0'>
//                   <CardBody className='p-3'>
//                     <CardTitle className='fs-6 text-success'>Within Range</CardTitle>
//                     <h4 className='text-success'>{withinRange}</h4>
//                     <small className='text-muted'>{((withinRange / totalItems) * 100).toFixed(1)}%</small>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col md={2}>
//                 <Card className='text-center border-0'>
//                   <CardBody className='p-3'>
//                     <CardTitle className='fs-6 text-danger'>Out of Stock</CardTitle>
//                     <h4 className='text-danger'>{outOfStock}</h4>
//                     <small className='text-muted'>{((outOfStock / totalItems) * 100).toFixed(1)}%</small>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col md={2}>
//                 <Card className='text-center border-0'>
//                   <CardBody className='p-3'>
//                     <CardTitle className='fs-6 text-info'>Need Reorder</CardTitle>
//                     <h4 className='text-info'>{needReorder}</h4>
//                     <small className='text-muted'>{((needReorder / totalItems) * 100).toFixed(1)}%</small>
//                   </CardBody>
//                 </Card>
//               </Col>
//             </Row>
//           )}

//           {/* Status Distribution */}
//           {data.length > 0 && (
//             <Card className='mb-4'>
//               <CardHeader>
//                 <h6 className='mb-0'>Inventory Status Distribution</h6>
//               </CardHeader>
//               <CardBody>
//                 <ProgressBar style={{ height: '25px' }}>
//                   <ProgressBar
//                     variant='danger'
//                     now={(belowMin / totalItems) * 100}
//                     key={1}
//                     label={`${belowMin} Below Min`}
//                   />
//                   <ProgressBar
//                     variant='warning'
//                     now={(aboveMax / totalItems) * 100}
//                     key={2}
//                     label={`${aboveMax} Above Max`}
//                   />
//                   <ProgressBar
//                     variant='success'
//                     now={(withinRange / totalItems) * 100}
//                     key={3}
//                     label={`${withinRange} In Range`}
//                   />
//                 </ProgressBar>
//               </CardBody>
//             </Card>
//           )}

//           {/* Results Section */}
//           {loading ? (
//             <div className='text-center my-5'>
//               <Spinner animation='border' role='status'>
//                 <span className='visually-hidden'>Loading...</span>
//               </Spinner>
//               <p className='mt-2'>Loading reorder point data...</p>
//             </div>
//           ) : filteredData.length > 0 ? (
//             <div className='table-responsive'>
//               <Table striped bordered hover>
//                 <thead>
//                   <tr>
//                     <th>Item Code</th>
//                     <th>Item Name</th>
//                     <th>On Hand Qty</th>
//                     <th>Min Qty</th>
//                     <th>Max Qty</th>
//                     <th>Reorder Point</th>
//                     <th>Inventory Level</th>
//                     <th>Status</th>
//                     <th>Urgency</th>
//                     <th>Action Required</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredData.map((item, index) => {
//                     const inventoryLevel = getInventoryLevel(item);
//                     const urgency = getUrgencyLevel(item);
//                     const progressVariant =
//                       urgency === 'critical'
//                         ? 'danger'
//                         : urgency === 'high'
//                         ? 'warning'
//                         : urgency === 'medium'
//                         ? 'info'
//                         : 'success';

//                     return (
//                       <tr key={`${item.itemId}-${index}`}>
//                         <td className='fw-bold'>{item.itemCode}</td>
//                         <td>
//                           <div>{item.itemName}</div>
//                           {item.itemName2 && <div className='text-muted small'>{item.itemName2}</div>}
//                         </td>
//                         <td
//                           className={`fw-bold ${
//                             item.onHandQty === 0
//                               ? 'text-danger'
//                               : item.onHandQty < item.minQty
//                               ? 'text-warning'
//                               : 'text-success'
//                           }`}
//                         >
//                           {formatQuantity(item.onHandQty)}
//                         </td>
//                         <td>{formatQuantity(item.minQty)}</td>
//                         <td>{formatQuantity(item.maxQty)}</td>
//                         <td>{formatQuantity(item.reorderPoint)}</td>
//                         <td>
//                           <div className='d-flex align-items-center'>
//                             <div className='flex-grow-1 me-2'>
//                               <ProgressBar variant={progressVariant} now={inventoryLevel} style={{ height: '8px' }} />
//                             </div>
//                             <small className='text-muted'>{inventoryLevel.toFixed(0)}%</small>
//                           </div>
//                         </td>
//                         <td>
//                           <Badge bg={getStatusBadgeColor(item.status)}>{item.status}</Badge>
//                         </td>
//                         <td>
//                           {urgency === 'critical' && <Badge bg='danger'>Critical</Badge>}
//                           {urgency === 'high' && <Badge bg='warning'>High</Badge>}
//                           {urgency === 'medium' && <Badge bg='info'>Medium</Badge>}
//                           {urgency === 'low' && <Badge bg='success'>Low</Badge>}
//                         </td>
//                         <td>
//                           {item.onHandQty === 0 && <Badge bg='danger'>Urgent Reorder</Badge>}
//                           {item.onHandQty < item.minQty && item.onHandQty > 0 && (
//                             <Badge bg='warning'>Reorder Now</Badge>
//                           )}
//                           {item.onHandQty > item.maxQty && <Badge bg='info'>Reduce Stock</Badge>}
//                           {item.onHandQty >= item.minQty && item.onHandQty <= item.maxQty && (
//                             <Badge bg='success'>Optimal</Badge>
//                           )}
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </Table>
//             </div>
//           ) : (
//             <div className='text-center py-5'>
//               <p>No data available. Set your filters and click "Load Report" to generate.</p>
//             </div>
//           )}
//         </CardBody>

//         {data.length > 0 && (
//           <CardFooter className='text-muted'>
//             <div className='row'>
//               <div className='col-md-6'>
//                 <small>
//                   <strong>Inventory Status:</strong>{' '}
//                   <Badge bg='danger' className='me-1'>
//                     Below Minimum
//                   </Badge>
//                   <Badge bg='warning' className='me-1'>
//                     Above Maximum
//                   </Badge>
//                   <Badge bg='success' className='me-1'>
//                     Within Range
//                   </Badge>
//                 </small>
//               </div>
//               <div className='col-md-6 text-end'>
//                 <small>Report generated on {new Date().toLocaleString()}</small>
//               </div>
//             </div>
//           </CardFooter>
//         )}
//       </Card>
//     </div>
//   );
// };

// export default ReorderPointReport;

import React, { useState } from 'react';
import {
  Table,
  Spinner,
  Form,
  Row,
  Col,
  Button,
  Alert,
  Badge,
  CardFooter,
  CardTitle,
  ProgressBar
} from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { Card, CardBody, CardHeader } from '@components/card/card';
import { ntxAPI } from '@API/axiosNeatex';
import useGetItemsList from '@hooks/INV/MasterItems/useGetItemsList';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import type { APIResponse } from '@store/Shared/shared';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
import Loading from '@components/Shared/Loader/Loading';

interface ReorderPoint {
  itemId: string;
  itemCode: string;
  itemName: string;
  itemName2: string;
  onHandQty: number;
  minQty: number;
  maxQty: number;
  reorderPoint: number;
  status: string;
}

const ReorderPointReport: React.FC = () => {
  const [data, setData] = useState<ReorderPoint[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const { ItemsOptions, loading: loading1, error: error1 } = useGetItemsList();
  const { InventoryOptions, loading: loading2, error: error2 } = useGetInventoryWithPermission();
  const { t, i18n } = useTranslation();
  // const [showZeroQuantity, setShowZeroQuantity] = useState<boolean>(false);

  const [statusFilter, setStatusFilter] = useState<string>('all');
  const [urgencyFilter, setUrgencyFilter] = useState<string>('all');

  // Filter states
  const [itemId, setItemId] = useState<string | null>(null);
  const [inventoryId, setInventoryId] = useState<string | null>(null);

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await ntxAPI.get<APIResponse<ReorderPoint[]>>(`InventoryReports/reorder-point`, {
        params: {
          ItemId: itemId,
          InventoryId: inventoryId
        }
      });

      if (data.succeeded === true) {
        setData(data.data);
      } else {
        setError(data instanceof Error ? data.message : t('UnknownError'));
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : t('UnknownError'));
    } finally {
      setLoading(false);
    }
  };

  const resetFilters = () => {
    setItemId(null);
    setInventoryId(null);
    setStatusFilter('all');
    setUrgencyFilter('all');
  };

  // Get unique statuses for dropdown
  const getUniqueStatuses = () => {
    const statuses = data.map(item => item.status);
    return Array.from(new Set(statuses));
  };

  // Get unique items for dropdown (optional)
  const getUniqueItems = () => {
    const items = data.map(item => ({
      id: item.itemId,
      code: item.itemCode,
      name: item.itemName
    }));

    return Array.from(new Map(items.map(item => [item.id, item])).values());
  };

  const formatQuantity = (quantity: number): string => {
    return new Intl.NumberFormat('en-US').format(quantity);
  };

  // Get status badge color
  const getStatusBadgeColor = (status: string) => {
    const statusMap: { [key: string]: string } = {
      'Below Minimum': 'danger',
      'Above Maximum': 'warning',
      'Within Range': 'success',
      'At Reorder Point': 'info',
      'أقل من الحد الأدنى': 'danger',
      'أعلى من الحد الأقصى': 'warning',
      'ضمن النطاق': 'success',
      'عند نقطة إعادة الطلب': 'info'
    };
    return statusMap[status] || 'secondary';
  };

  // Translate status
  const translateStatus = (status: string) => {
    const statusTranslations: { [key: string]: string } = {
      'Below Minimum': 'أقل من الحد الأدنى',
      'Above Maximum': 'أعلى من الحد الأقصى',
      'Within Range': 'ضمن النطاق',
      'At Reorder Point': 'عند نقطة إعادة الطلب'
    };
    return i18n.language === 'en' ? status : statusTranslations[status] || status;
  };

  // Calculate urgency level
  const getUrgencyLevel = (item: ReorderPoint) => {
    if (item.onHandQty === 0) return 'critical';
    if (item.onHandQty < item.minQty) return 'high';
    if (item.onHandQty > item.maxQty) return 'medium';
    return 'low';
  };

  // Calculate inventory level percentage
  const getInventoryLevel = (item: ReorderPoint) => {
    if (item.maxQty === 0) return 0;
    return Math.min((item.onHandQty / item.maxQty) * 100, 100);
  };

  // Calculate inventory statistics
  const calculateInventoryStats = () => {
    const belowMin = data.filter(
      item => item.status === 'Below Minimum' || item.status === 'أقل من الحد الأدنى'
    ).length;
    const aboveMax = data.filter(
      item => item.status === 'Above Maximum' || item.status === 'أعلى من الحد الأقصى'
    ).length;
    const withinRange = data.filter(item => item.status === 'Within Range' || item.status === 'ضمن النطاق').length;
    const totalItems = data.length;
    const outOfStock = data.filter(item => item.onHandQty === 0).length;
    const needReorder = data.filter(item => item.onHandQty <= item.minQty && item.onHandQty > 0).length;

    return { belowMin, aboveMax, withinRange, totalItems, outOfStock, needReorder };
  };

  // Filter data based on status and urgency
  const filteredData = data.filter(item => {
    if (statusFilter !== 'all' && item.status !== statusFilter) return false;

    if (urgencyFilter !== 'all') {
      const urgency = getUrgencyLevel(item);
      if (urgencyFilter === 'critical' && urgency !== 'critical') return false;
      if (urgencyFilter === 'high' && urgency !== 'high') return false;
      if (urgencyFilter === 'medium' && urgency !== 'medium') return false;
      if (urgencyFilter === 'low' && urgency !== 'low') return false;
    }

    return true;
  });

  const { belowMin, aboveMax, withinRange, totalItems, outOfStock, needReorder } = calculateInventoryStats();

  // Text direction based on language
  const isRTL = i18n.language === 'ar';
  const textDirection = isRTL ? 'rtl' : 'ltr';

  return (
    <div className='container mt-4' dir={textDirection}>
      <Card>
        <CardHeader className='d-flex justify-content-between align-items-center'>
          <h5 className='mb-0'>{i18n.language === 'en' ? 'Reorder Point Report' : 'تقرير نقطة إعادة الطلب'}</h5>
          {data.length > 0 && (
            <div>
              <span className='me-2'>
                {i18n.language === 'en'
                  ? `Showing: ${filteredData.length} of ${data.length} items`
                  : `عرض: ${filteredData.length} من ${data.length} عنصر`}
              </span>
            </div>
          )}
        </CardHeader>

        <CardBody>
          {error && (
            <Alert variant='danger' className='mb-4'>
              {i18n.language === 'en' ? 'Error loading data:' : 'خطأ في تحميل البيانات:'} {error}
            </Alert>
          )}

          {/* Filters Section */}
          <Card className='mb-4'>
            <CardHeader>{i18n.language === 'en' ? 'Filters' : 'الفلاتر'}</CardHeader>
            <Loading loading={loading1 || loading2} error={error1 || error2}>
              <CardBody>
                <Form>
                  <Row className='g-3'>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>{t('itemName')}</Form.Label>
                        <Select
                          classNamePrefix='react-select'
                          isSearchable
                          isClearable
                          options={ItemsOptions}
                          onChange={(option: any) => setItemId(option?.value || null)}
                          value={ItemsOptions.find(f => f.value === itemId)}
                          placeholder={t('Choose')}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                          }}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>{t('Inventory')}</Form.Label>
                        <Select
                          classNamePrefix='react-select'
                          isSearchable={true}
                          isClearable
                          options={InventoryOptions}
                          onChange={(option: any) => {
                            setInventoryId(option === null ? null : option.value);
                          }}
                          placeholder={t('Choose')}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group controlId='urgencyFilter'>
                        <Form.Label>{i18n.language === 'en' ? 'Urgency Level' : 'مستوى الاستعجال'}</Form.Label>
                        <Form.Select value={urgencyFilter} onChange={e => setUrgencyFilter(e.target.value)}>
                          <option value='all'>
                            {i18n.language === 'en' ? 'All Urgency Levels' : 'جميع مستويات الاستعجال'}
                          </option>
                          <option value='critical'>
                            {i18n.language === 'en' ? 'Critical (Out of Stock)' : 'حرج (نفاد المخزون)'}
                          </option>
                          <option value='high'>
                            {i18n.language === 'en' ? 'High (Below Minimum)' : 'مرتفع (أقل من الحد الأدنى)'}
                          </option>
                          <option value='medium'>
                            {i18n.language === 'en' ? 'Medium (Above Maximum)' : 'متوسط (أعلى من الحد الأقصى)'}
                          </option>
                          <option value='low'>
                            {i18n.language === 'en' ? 'Low (Within Range)' : 'منخفض (ضمن النطاق)'}
                          </option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col xs={12} className={`text-end`}>
                      <Button variant='secondary' onClick={resetFilters} className='me-2'>
                        {i18n.language === 'en' ? 'Reset Filters' : 'إعادة تعيين الفلاتر'}
                      </Button>
                      <Button variant='primary' onClick={fetchData} disabled={loading}>
                        {loading ? (
                          <>
                            <Spinner
                              as='span'
                              animation='border'
                              size='sm'
                              role='status'
                              aria-hidden='true'
                              className='me-2'
                            />
                            {i18n.language === 'en' ? 'Loading...' : 'جاري التحميل...'}
                          </>
                        ) : i18n.language === 'en' ? (
                          'Load Report'
                        ) : (
                          'تحميل التقرير'
                        )}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Loading>
          </Card>

          {/* Inventory Status Summary */}
          {data.length > 0 && (
            <Row className='mb-4'>
              <Col md={2}>
                <Card className='text-center shadow-sm '>
                  <CardBody className='p-3'>
                    <CardTitle className='fs-6 text-primary'>
                      {i18n.language === 'en' ? 'Total Items' : 'إجمالي الأصناف'}
                    </CardTitle>
                    <h4 className='text-primary'>{totalItems}</h4>
                  </CardBody>
                </Card>
              </Col>
              <Col md={2}>
                <Card className='text-center  shadow-sm'>
                  <CardBody className='p-3'>
                    <CardTitle className='fs-6 text-danger'>
                      {i18n.language === 'en' ? 'Below Minimum' : 'أقل من الحد الأدنى'}
                    </CardTitle>
                    <h4 className='text-danger'>{belowMin}</h4>
                    <small className='text-muted'>{((belowMin / totalItems) * 100).toFixed(1)}%</small>
                  </CardBody>
                </Card>
              </Col>
              <Col md={2}>
                <Card className='text-center  shadow-sm'>
                  <CardBody className='p-3'>
                    <CardTitle className='fs-6 text-warning'>
                      {i18n.language === 'en' ? 'Above Maximum' : 'أعلى من الحد الأقصى'}
                    </CardTitle>
                    <h4 className='text-warning'>{aboveMax}</h4>
                    <small className='text-muted'>{((aboveMax / totalItems) * 100).toFixed(1)}%</small>
                  </CardBody>
                </Card>
              </Col>
              <Col md={2}>
                <Card className='text-center  shadow-sm'>
                  <CardBody className='p-3'>
                    <CardTitle className='fs-6 text-success'>
                      {i18n.language === 'en' ? 'Within Range' : 'ضمن النطاق'}
                    </CardTitle>
                    <h4 className='text-success'>{withinRange}</h4>
                    <small className='text-muted'>{((withinRange / totalItems) * 100).toFixed(1)}%</small>
                  </CardBody>
                </Card>
              </Col>
              <Col md={2}>
                <Card className='text-center  shadow-sm'>
                  <CardBody className='p-3'>
                    <CardTitle className='fs-6 text-danger'>
                      {i18n.language === 'en' ? 'Out of Stock' : 'نفاد المخزون'}
                    </CardTitle>
                    <h4 className='text-danger'>{outOfStock}</h4>
                    <small className='text-muted'>{((outOfStock / totalItems) * 100).toFixed(1)}%</small>
                  </CardBody>
                </Card>
              </Col>
              <Col md={2}>
                <Card className='text-center  shadow-sm'>
                  <CardBody className='p-3'>
                    <CardTitle className='fs-6 text-info'>
                      {i18n.language === 'en' ? 'Need Reorder' : 'بحاجة لإعادة طلب'}
                    </CardTitle>
                    <h4 className='text-info'>{needReorder}</h4>
                    <small className='text-muted'>{((needReorder / totalItems) * 100).toFixed(1)}%</small>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

          {/* Status Distribution */}
          {data.length > 0 && (
            <Card className='mb-4'>
              <CardHeader>
                <h6 className='mb-0'>
                  {i18n.language === 'en' ? 'Inventory Status Distribution' : 'توزيع حالة المخزون'}
                </h6>
              </CardHeader>
              <CardBody>
                <ProgressBar style={{ height: '25px' }}>
                  <ProgressBar
                    variant='danger'
                    now={(belowMin / totalItems) * 100}
                    key={1}
                    label={`${belowMin} ${i18n.language === 'en' ? 'Below Min' : 'أقل من الأدنى'}`}
                  />
                  <ProgressBar
                    variant='warning'
                    now={(aboveMax / totalItems) * 100}
                    key={2}
                    label={`${aboveMax} ${i18n.language === 'en' ? 'Above Max' : 'أعلى من الأقصى'}`}
                  />
                  <ProgressBar
                    variant='success'
                    now={(withinRange / totalItems) * 100}
                    key={3}
                    label={`${withinRange} ${i18n.language === 'en' ? 'In Range' : 'ضمن النطاق'}`}
                  />
                </ProgressBar>
              </CardBody>
            </Card>
          )}

          {/* Results Section */}
          {loading ? (
            <div className='text-center my-5'>
              <Spinner animation='border' role='status'>
                <span className='visually-hidden'>{i18n.language === 'en' ? 'Loading...' : 'جاري التحميل...'}</span>
              </Spinner>
              <p className='mt-2'>
                {i18n.language === 'en' ? 'Loading reorder point data...' : 'جاري تحميل بيانات نقطة إعادة الطلب...'}
              </p>
            </div>
          ) : filteredData.length > 0 ? (
            <div className='table-responsive'>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>{i18n.language === 'en' ? 'Item Code' : 'كود الصنف'}</th>
                    <th>{i18n.language === 'en' ? 'Item Name' : 'اسم الصنف'}</th>
                    <th>{i18n.language === 'en' ? 'On Hand Qty' : 'الكمية المتاحة'}</th>
                    <th>{i18n.language === 'en' ? 'Min Qty' : 'الحد الأدنى'}</th>
                    <th>{i18n.language === 'en' ? 'Max Qty' : 'الحد الأقصى'}</th>
                    <th>{i18n.language === 'en' ? 'Reorder Point' : 'نقطة إعادة الطلب'}</th>
                    <th>{i18n.language === 'en' ? 'Inventory Level' : 'مستوى المخزون'}</th>
                    <th>{i18n.language === 'en' ? 'Status' : 'الحالة'}</th>
                    <th>{i18n.language === 'en' ? 'Urgency' : 'الاستعجال'}</th>
                    <th>{i18n.language === 'en' ? 'Action Required' : 'الإجراء المطلوب'}</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((item, index) => {
                    const inventoryLevel = getInventoryLevel(item);
                    const urgency = getUrgencyLevel(item);
                    const progressVariant =
                      urgency === 'critical'
                        ? 'danger'
                        : urgency === 'high'
                        ? 'warning'
                        : urgency === 'medium'
                        ? 'info'
                        : 'success';

                    // Translate urgency levels
                    const getUrgencyText = () => {
                      switch (urgency) {
                        case 'critical':
                          return i18n.language === 'en' ? 'Critical' : 'حرج';
                        case 'high':
                          return i18n.language === 'en' ? 'High' : 'مرتفع';
                        case 'medium':
                          return i18n.language === 'en' ? 'Medium' : 'متوسط';
                        case 'low':
                          return i18n.language === 'en' ? 'Low' : 'منخفض';
                        default:
                          return urgency;
                      }
                    };

                    // Translate action required
                    const getActionRequired = () => {
                      if (item.onHandQty === 0) return i18n.language === 'en' ? 'Urgent Reorder' : 'إعادة طلب عاجلة';
                      if (item.onHandQty < item.minQty && item.onHandQty > 0)
                        return i18n.language === 'en' ? 'Reorder Now' : 'إعادة طلب الآن';
                      if (item.onHandQty > item.maxQty)
                        return i18n.language === 'en' ? 'Reduce Stock' : 'تقليل المخزون';
                      if (item.onHandQty >= item.minQty && item.onHandQty <= item.maxQty)
                        return i18n.language === 'en' ? 'Optimal' : 'مثالي';
                      return i18n.language === 'en' ? 'Monitor' : 'مراقبة';
                    };

                    // Get action badge color
                    const getActionBadgeColor = () => {
                      if (item.onHandQty === 0) return 'danger';
                      if (item.onHandQty < item.minQty && item.onHandQty > 0) return 'warning';
                      if (item.onHandQty > item.maxQty) return 'info';
                      return 'success';
                    };

                    return (
                      <tr key={`${item.itemId}-${index}`}>
                        <td className='fw-bold'>{item.itemCode}</td>
                        <td>
                          <div>{i18n.language === 'en' ? item.itemName : item.itemName2 || item.itemName}</div>
                          {item.itemName2 && (
                            <div className='text-muted small'>
                              {i18n.language === 'en' ? item.itemName2 : item.itemName}
                            </div>
                          )}
                        </td>
                        <td
                          className={`fw-bold ${
                            item.onHandQty === 0
                              ? 'text-danger'
                              : item.onHandQty < item.minQty
                              ? 'text-warning'
                              : 'text-success'
                          }`}
                        >
                          {formatQuantity(item.onHandQty)}
                        </td>
                        <td>{formatQuantity(item.minQty)}</td>
                        <td>{formatQuantity(item.maxQty)}</td>
                        <td>{formatQuantity(item.reorderPoint)}</td>
                        <td>
                          <div className=' align-items-center'>
                            <small className='text-muted'>{inventoryLevel.toFixed(0)}%</small>
                            <br />
                            <div className='flex-grow-1 me-2'>
                              <ProgressBar variant={progressVariant} now={inventoryLevel} style={{ height: '8px' }} />
                            </div>
                          </div>
                        </td>
                        <td>
                          <Badge bg={getStatusBadgeColor(item.status)}>{translateStatus(item.status)}</Badge>
                        </td>
                        <td>
                          <Badge
                            bg={
                              urgency === 'critical'
                                ? 'danger'
                                : urgency === 'high'
                                ? 'warning'
                                : urgency === 'medium'
                                ? 'info'
                                : 'success'
                            }
                          >
                            {getUrgencyText()}
                          </Badge>
                        </td>
                        <td>
                          <Badge bg={getActionBadgeColor()}>{getActionRequired()}</Badge>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className='text-center py-5'>
              <p>
                {i18n.language === 'en'
                  ? 'No data available. Set your filters and click "Load Report" to generate.'
                  : 'لا توجد بيانات متاحة. قم بتعيين الفلاتر الخاصة بك وانقر على "تحميل التقرير" لإنشائه.'}
              </p>
            </div>
          )}
        </CardBody>

        {data.length > 0 && (
          <CardFooter className='text-muted'>
            <div className='row'>
              <div className='col-md-6'>
                <small>
                  <strong>{i18n.language === 'en' ? 'Inventory Status:' : 'حالة المخزون:'}</strong>{' '}
                  <Badge bg='danger' className='me-1'>
                    {i18n.language === 'en' ? 'Below Minimum' : 'أقل من الحد الأدنى'}
                  </Badge>
                  <Badge bg='warning' className='me-1'>
                    {i18n.language === 'en' ? 'Above Maximum' : 'أعلى من الحد الأقصى'}
                  </Badge>
                  <Badge bg='success' className='me-1'>
                    {i18n.language === 'en' ? 'Within Range' : 'ضمن النطاق'}
                  </Badge>
                </small>
              </div>
              <div className={`col-md-6 text-${isRTL ? 'start' : 'end'}`}>
                <small>
                  {i18n.language === 'en'
                    ? `Report generated on ${new Date().toLocaleString()}`
                    : `تم إنشاء التقرير في ${new Date().toLocaleString('ar-EG')}`}
                </small>
              </div>
            </div>
          </CardFooter>
        )}
      </Card>
    </div>
  );
};

export default ReorderPointReport;
